import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

import {RhynoApiProvider} from '../../providers/rhyno-api/rhyno-api';

/**
 * Generated class for the InboxCreateTimeeventPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-inbox-create-timeevent',
  templateUrl: 'inbox-create-timeevent.html',
})
export class InboxCreateTimeeventPage {
  Projekte = [];
  Leistungsartikel = [];
  selectedLeistungsartikel = 'D100100';
  selectedProjekt = '';

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private rhynoApi: RhynoApiProvider, 
    public viewCtrl: ViewController) {
   
    var filter = {Kunde:''};
    if (navParams.data.Kunde){
      filter.Kunde = navParams.data.Kunde;
    }


   this.rhynoApi.getProjekt(filter).subscribe(
      data => {
        if (data.success){
          this.Projekte = data.data; 
        }
        console.log(data);
      },
        err => {
        console.log(err);
      },
      () => console.log('Projekt Search Complete')
    );

   this.rhynoApi.getLeistungsartikel('').subscribe(
      data => {
      if (data.success){
        this.Leistungsartikel = data.data; 
        console.log(data);
      }
    },
      err => {
      console.log(err);
    },
    () => console.log('Leistungsartikel Search Complete')
    );

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InboxCreateTimeeventPage');
  }
  save() {

    var resultProjekt = this.Projekte.filter(data => {
      return data.Id == this.selectedProjekt;
    });
    if (!resultProjekt[0]){
      return;
    }

    var resultLeistungsartikel = this.Leistungsartikel.filter(data => {
      return data.Artikelnummer == this.selectedLeistungsartikel;
    });
    if (!resultLeistungsartikel[0]){
      return;
    }


    let data = { 
      Leistung:resultLeistungsartikel[0].Artikelnummer,  
      Beschreibung:resultLeistungsartikel[0].Bezeichnung,  
      Kunde:resultProjekt[0].Kunde,
      KundeName:resultProjekt[0].KundeName,
      ProjektID: resultProjekt[0].Id,
      ProjektIDExt: resultProjekt[0].Projekt,
      ProjektBezeichnung: resultProjekt[0].Bezeichnung
    };

    this.viewCtrl.dismiss(data);
  }

  cancel() {
    this.viewCtrl.dismiss();
  }
  selectLeistungsartikel(data){

  }

  selectProjekt(data){

  }

}



// WEBPACK FOOTER //
// ./src/pages/inbox-create-timeevent/inbox-create-timeevent.ts